import { Vue, Component, Prop } from "vue-property-decorator";
import * as ajax from "@brightspark/sparkling-ajax-js";

interface IComponentData {
    groups: Array<IGalleryGroup>,
    dataUrl: string,
    isDataRequestInProgress: boolean;
    filter: IFilter;
}

interface IModel {
    columnAmount: number;
    dataUrl: string;
    filter: IFilter;
    groups: Array<IGalleryGroup>;
}

interface IFilter {
    month: number;
    year: number;
}

interface IGalleryGroup {
    title: string;
    galleryGroups: Array<IGalleryTitle>;
}

interface IGalleryTitle {
    id: string;
    title: string;
    imgUrl: string;
    images: Array<IMediaItem>;
}

interface IMediaItem {
    thumb: string;
    url: string;
    imageSize: {
        width: number;
        height: number;
    }
}

interface IDisplayGroup {
    title: string;
    galleryGroups: Array<Array<IGalleryTitle>>;
}

@Component
export default class GallerySlider extends Vue {
    @Prop() model: IModel;
    //@Prop() cols: number;

    private _cols: number;

    private _data: IComponentData;
    private _totalCount: number;

    data() {
        this._cols = this.model.columnAmount;
        //this.$set(this, 'cols', this.model.columnAmount);

        return {
            currentSlideNo: 1,
            dataUrl: this.model.dataUrl,
            filter: this.model.filter,
            groups: this.model.groups,
            isDataRequestInProgress: false
        } as IComponentData;
    }

    mounted() {
        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        let newAmount = this.getColumnAmount();
        if (this._cols !== newAmount) {
            this.$set(this, 'cols', newAmount);
        }
    }

    next() {
        this.slideForward();
    }

    private slideForward() {
        if (this._data.isDataRequestInProgress || !this._data.filter) {
            return;
        }
        
        this._data.isDataRequestInProgress = true;
        ajax(this._data.dataUrl, { dataType: "json", method: "post", data: this._data.filter })
            .done((model: IModel) => {
                if (!model) {
                    return;
                }

                for (let i = 0; i < model.groups.length; i++) {
                    this.model.groups.push(model.groups[i]);
                }

                this._data.filter = model.filter;

                this._data.isDataRequestInProgress = false;
            });
    }

    public showLightbox(images: Array<IMediaItem>): void {
        this.$parent.$emit('show-lightbox', 0, images);
    }

    private getColumnAmount() {
        let screenSize = {
            mobileSmall: 650,
            mobile: 767,
            tablet: 1023
        };

        let articlesPerSlide = this.model.columnAmount;
        let currentWindowWidth = window.innerWidth;
        if (currentWindowWidth < screenSize.tablet) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobile) {
            articlesPerSlide = 2;
        }
        if (currentWindowWidth < screenSize.mobileSmall) {
            articlesPerSlide = 1;
        }
        return articlesPerSlide;
    }

    private getGalleries(): Array<IDisplayGroup> {
        var res = [] as Array<IDisplayGroup>;
        for (let i = 0; i < this.model.groups.length; i++) {
            res.push({
                title: this.model.groups[i].title,
                galleryGroups: this.divideByCols(i)
            } as IDisplayGroup);
        }
        return res;
    }

    private divideByCols(index: number): Array<Array<IGalleryTitle>> {
        var articlesPerSlide = this.getColumnAmount();
        var res = [] as Array<Array<IGalleryTitle>>;

        var galleryGroup = this._data.groups[index].galleryGroups;
        for (var row = 0; row < articlesPerSlide; row++) {
            var col = [] as Array<IGalleryTitle>;
            res.push(col);
            for (var i = row; i < galleryGroup.length; i += articlesPerSlide) {
                col.push(galleryGroup[i]);
            }
        }
        return res;
    }

    get galleries() {
        // hack to make it reactive
        let colAmount = this._cols;

        var res = [] as Array<IDisplayGroup>;
        for (let i = 0; i < this.model.groups.length; i++) {
            res.push({
                title: this.model.groups[i].title,
                galleryGroups: this.divideByCols(i)
            } as IDisplayGroup);
        }
        return res;
    }

    get nextButtonClass(): Array<string> {
        var classList = ["button", "button--secondary-down", "button--tiny"];

        if (!this._data.filter) {
            classList.push("button--disabled");
        }
        return classList;
    }

    get imgRowClass(): Array<string> {
        var classList = ["table__row"];
        classList.push("table__row--col" + this._cols);
        return classList;
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/GallerySlider/GallerySlider.ts